import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE
} from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OrderService } from 'src/entities/order';
import {
  formatScheduledPaymentDate,
  parseScheduledPaymentDateForInput
} from 'src/entities/order/lib/apply-order-to-services';

const CORTE_DATE_FORMATS = {
  parse: { dateInput: 'DD/MM/YYYY' },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

export interface OrderFreezeDeadlineDialogData {
  orderId: string;
  freezeDeadlineAt?: string | null;
  orderLabel?: string | number | null;
}

export interface OrderFreezeDeadlineDialogResult {
  freezeDeadlineAt: string;
}

@Component({
  selector: 'app-order-freeze-deadline-dialog',
  templateUrl: './order-freeze-deadline-dialog.component.html',
  styleUrls: ['./order-freeze-deadline-dialog.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: CORTE_DATE_FORMATS }
  ]
})
export class OrderFreezeDeadlineDialogComponent implements OnInit {
  readonly dateControl = new FormControl<Date | null>(null, Validators.required);
  saving = false;
  error = '';

  constructor(
    private readonly orderService: OrderService,
    private readonly dialogRef: MatDialogRef<
      OrderFreezeDeadlineDialogComponent,
      OrderFreezeDeadlineDialogResult
    >,
    @Inject(MAT_DIALOG_DATA) public data: OrderFreezeDeadlineDialogData
  ) {}

  ngOnInit(): void {
    const current = parseScheduledPaymentDateForInput(this.data.freezeDeadlineAt);
    if (current) {
      this.dateControl.setValue(current);
    }
  }

  close(): void {
    if (this.saving) {
      return;
    }
    this.dialogRef.close();
  }

  save(): void {
    const value = this.asDate(this.dateControl.value);
    if (!value || this.saving) {
      this.dateControl.markAsTouched();
      return;
    }
    const freezeDeadlineAt = formatScheduledPaymentDate(value);
    this.saving = true;
    this.error = '';
    this.orderService
      .updateOrderFreezeDeadline(this.data.orderId, freezeDeadlineAt)
      .subscribe({
        next: () => {
          this.saving = false;
          this.dialogRef.close({ freezeDeadlineAt });
        },
        error: () => {
          this.saving = false;
          this.error = 'No se pudo guardar la fecha.';
        }
      });
  }

  private asDate(value: unknown): Date | null {
    if (!value) {
      return null;
    }
    if (value instanceof Date) {
      return value;
    }
    if (
      typeof value === 'object' &&
      value !== null &&
      'toDate' in value &&
      typeof (value as { toDate: () => Date }).toDate === 'function'
    ) {
      return (value as { toDate: () => Date }).toDate();
    }
    const parsed = new Date(value as string);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }
}
